<style>
.medical-document__footer {
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  width: 100%;
}

.medical-document__signature {
  align-items: flex-end;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 250px;
}

.medical-document__signature-img {
  height: auto;
  width: 250px;
}

.medical-document__signature-text {
  border-top: 1px solid rgb(221, 221, 221);
  font-family: 'Open Sans';
  font-size: 0.7rem;
  margin: 0;
  margin-top: 0.5rem;
  padding: 0;
  padding-top: 0.5rem;
  text-align: center;
  width: 250px;
}
</style>

<template>
  <footer class="medical-document__footer">
    <div class="medical-document__signature">
      <img
        v-if="signature"
        :src="signature"
        class="medical-document__signature-img"
      >

      <p class="medical-document__signature-text">
        Assinatura do emitente
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'DrPrintTemplateFooter',

  props: {
    doctor: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      signature: null
    }
  },

  created () {
    if (this.doctor['signature_picture']) {
      this.signature = `${process.env.ROOT_API}/s3/file/doctor/${this.doctor.id}/signature_picture`
    }
  }
}
</script>
